module.exports = __webpack_public_path__ + "img/cart-green-bg.c4375fe2.jpg";